// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__35zeg","tab":"ProcedureTabs_tab__32Pd8"};